import React, { useEffect, useState } from 'react';
import useChrOffCanvas from '../../../../../../hooks/generic/PageUI/useChrOffCanvas';
import ChronusApi from '../../../../../../services/ChronusApi';
import i18n from '../../../../../../utils/ChrI18n';
import { chronusStore } from '../../../../../../chronusStore';
import { useDispatch, useSelector } from '../../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../../chronusStore/slice/eventsListing';
import SpinningLoader from '../../../../../generic/Utils/SpinningLoader';
import InnerHTML from '../../../../../generic/Utils/InnerHtml';
import { formatToISODate } from '../../../../../generic/Utils/commonUtils';
import CallToAction from '../../../templates/CallToAction';
import RsvpInfo from '../../../templates/rsvpInfo';
import SlotsInfo from '../../../templates/SlotsInfo';
import InviteDetails from './InviteDetails';
import EventImage from './EventImage';
import EventDetails from './EventDetails';

const QuickView = ({ fetchUrl, unSetQuickViewEventId, calendarAttrs }) => {
  const dispatch = useDispatch();
  const [eventData, setEventData] = useState();
  const { OffCanvasComponent, offCanvasActions, offCanvasOptions } = useChrOffCanvas();
  const quickViewEventId = useSelector(state => state.eventsListing.quickViewEventId);
  const refreshQuickView = useSelector(state => state.eventsListing.refreshQuickView);
  const page = useSelector(state => state.eventsListing.page);
  const inviteDetail = eventData => <InviteDetails inviteDetails={ eventData.inviteDetails } eventId={ eventData.id }/>;

  const canvasCloseHandler = () => {
    if(calendarAttrs && chronusStore.getState().eventsListing.refreshCalendar) {
      dispatch(eventsListingActions.updateRefreshCalendar(false));
      calendarAttrs.calendarRef.current.getApi().refetchEvents();
    }
    offCanvasActions.closeHandler();
    unSetQuickViewEventId();
    setEventData();

    if(refreshQuickView){
      dispatch(eventsListingActions.updateRefreshQuickView(false));
      dispatch(eventsListingActions.incrementReRenderTabContentCounter());
    }
  };

  const getInitialDate = () => {
    if(calendarAttrs)
      return formatToISODate(calendarAttrs.calendarRef.current.calendar.currentData.dateProfile.currentDate);
  };

  useEffect(() => {
    if(quickViewEventId) {
      const data = {
        page: page + 1,
        initialDate: getInitialDate(),
        isCalendarView: chronusStore.getState().eventsListing.isCalendarView,
        ...chronusStore.getState().eventsListing.filters
      }
      if(!refreshQuickView) data.currentTab = chronusStore.getState().eventsListing.currentTab

      offCanvasActions.openHandler();
      ChronusApi.getUrlJSON(
        fetchUrl + quickViewEventId,
        data
      ).then(response => {
        setEventData(response);
      }).catch(_error => {
        ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
      });
    }
  }, [quickViewEventId, refreshQuickView]);

  useEffect(() => {
    setEventData();
  }, [refreshQuickView])

  return (
    <div className="cui-management-report-temp cui-event-quick-view">
      <OffCanvasComponent { ...offCanvasOptions }
        widthClass='cui-quick-view-responsive-width custom-thin-scroll-bar no-border-radius'
        onClose={ canvasCloseHandler }
        header={{ text: i18n.t("feature.program_event.header.event_details") }}
        htmlBodyClass="cui-events-chr-off-canvas-open"
      >
        {
          eventData ?
            <div className="px-4" key={ eventData.id }>
              <EventImage image={ eventData.image }/>
              <div className='d-flex flex-column pt-2 mb-3'>
                <a href={ eventData.url } className='no-margins font-weight-bold h3 text-primary'>
                  { eventData.title }
                </a>
                <InnerHTML content={ eventData.hostedBy } containerClass='pt-1 text-muted break-word'/>
              </div>
              <div className='d-flex flex-column'>
                {
                  eventData.rsvpInfo ? <RsvpInfo header={ i18n.t('feature.meetings.header.rsvp') } { ...eventData.rsvpInfo } eventId={ eventData.id } >
                      { inviteDetail(eventData) }
                    </RsvpInfo> :
                    eventData.callToAction ? <div className='row mx-0'>
                      <div className='align-content-center'>
                        <CallToAction details={ eventData.callToAction } />
                      </div>
                      <div className='ml-auto'>
                        { inviteDetail(eventData) }
                      </div>
                    </div> :
                    inviteDetail(eventData)
                }
                {
                  eventData.slotsInfo && <SlotsInfo slotsInfo={ eventData.slotsInfo } eventId={ eventData.id }/>
                }
              </div>
              <EventDetails { ...eventData.eventDetails }/>
            </div> :
            <SpinningLoader/>
        }
      </OffCanvasComponent>
    </div>
  )
};

export default QuickView;